import React from "react";

export const SmallGoldIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_375_5331)">
      <path
        d="M12.2489 23.3332C18.5078 23.3332 23.5817 18.2593 23.5817 12.0004C23.5817 5.74143 18.5078 0.667542 12.2489 0.667542C5.9899 0.667542 0.916016 5.74143 0.916016 12.0004C0.916016 18.2593 5.9899 23.3332 12.2489 23.3332Z"
        fill="#BF7B18"
      />
      <path
        d="M12.2492 23.3331C6.0001 23.3331 0.916016 18.249 0.916016 11.9999C0.916016 5.75075 6.0001 0.667038 12.2492 0.667038C18.4984 0.667038 23.5825 5.75075 23.5825 11.9999C23.5825 18.249 18.498 23.3331 12.2492 23.3331Z"
        fill="white"
      />
      <path
        d="M17.991 4.01708C18.4748 4.01708 18.953 4.04195 19.4247 4.08717C17.5265 2.36409 15.008 1.31245 12.2483 1.31245C6.35526 1.31245 1.56055 6.10679 1.56055 12.0002C1.56055 14.1035 2.17397 16.0655 3.22748 17.7207C3.79343 10.0586 10.1842 4.01708 17.991 4.01708Z"
        fill="#F6D555"
      />
      <path
        d="M12.249 22.6878C18.142 22.6878 22.9367 17.8934 22.9367 12C22.9367 8.86657 21.581 6.044 19.4258 4.08693C18.954 4.04171 18.4759 4.01685 17.9921 4.01685C10.1856 4.01685 3.79446 10.0587 3.22852 17.7205C5.12643 20.7036 8.45955 22.6878 12.249 22.6878Z"
        fill="#EFB217"
      />
      <path
        d="M12.2499 20.4533C16.9183 20.4533 20.7029 16.6687 20.7029 12.0002C20.7029 7.33178 16.9183 3.54724 12.2499 3.54724C7.58141 3.54724 3.79688 7.33178 3.79688 12.0002C3.79688 16.6687 7.58141 20.4533 12.2499 20.4533Z"
        fill="#D79511"
      />
      <path
        d="M10.6777 10.3476L7.16406 10.8585L9.70667 13.3367L9.10644 16.8364L12.2493 15.1841V7.16368L10.6777 10.3476Z"
        fill="#F6D555"
      />
      <path
        d="M17.3352 10.8585L13.8212 10.3476L12.25 7.16368V15.1841L15.3928 16.8364L14.7926 13.3367L17.3352 10.8585Z"
        fill="#EFB217"
      />
      <path
        d="M18.3128 4.87952C18.4985 5.06528 19.1022 5.35202 19.3836 5.48013C19.4401 5.50575 19.4401 5.58563 19.3836 5.61125C19.1022 5.73936 18.4989 6.02573 18.3128 6.21186C18.127 6.39762 17.8403 7.00125 17.7122 7.28271C17.6865 7.33923 17.6067 7.33923 17.581 7.28271C17.4529 7.00125 17.1666 6.398 16.9804 6.21186C16.7947 6.0261 16.191 5.73936 15.9096 5.61125C15.8531 5.58563 15.8531 5.50575 15.9096 5.48013C16.191 5.35202 16.7943 5.06566 16.9804 4.87952C17.1662 4.69376 17.4529 4.09014 17.581 3.80867C17.6067 3.75215 17.6865 3.75215 17.7122 3.80867C17.8399 4.09014 18.1266 4.69338 18.3128 4.87952Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_375_5331">
        <rect
          width="22.6667"
          height="22.6667"
          fill="white"
          transform="translate(0.916016 0.666672)"
        />
      </clipPath>
    </defs>
  </svg>
);
